export function addProduct(id_product, id_product_old, callback, id_assembly)
{
    const recipeUrl = baseUrl + 'assembly/add-product/?type=' + window.type;;
    let postBody = {
        id_product: id_product,
        id_product_old: id_product_old,
        is_ajax: true
    };
    if(typeof id_assembly != 'undefined'){
        postBody.id_assembly = id_assembly;
    }

    const requestMetadata = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(postBody)
    };

    fetch(recipeUrl, requestMetadata)
        .then(res => res.json())
        .then(res => {
            callback(res);

        });
}